module.exports = __webpack_public_path__ + "static/img/Tom_McDonald_desktop.a27b30d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom_McDonald_desktop.jpg
// module id = hI36
// module chunks = 0